import React, { useCallback, useEffect, useRef, useState } from "react";
import InventoryDetails from "../components/InventoryDetails";
import Space from "../ui/Space";
import InventoryHistory from "../components/InventoryHistory";
//import { search } from "../temp";
import InventoryList from "../components/InventoryList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import { createModal } from "../hooks/createModal";
import InventorySearch from "../popups/InventorySearch";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import InventoryIndex from "../popups/InventoryIndex";
import InventoryMessage from "../popups/InventoryMessage";
import { addISBNDashes, convertDiscountToInt, diffObjs, getEnum, getEnumLabel, istl, kbdEvent, mergeArraysByKey, moveItemToTopByKey, requestPrompt, runEvent, showConfirm, showInfo, showOptions, supplierToGroupKey } from "../utils/Utils";
import InventoryAdjust from "../popups/InventoryAdjust";
import InventoryPubstock from "../components/InventoryPubstock";
import Confirm from "../popups/Confirm";
import Divider from "../ui/Divider";
import { stock_structure } from "../data_structures/Stock";
import InventoryExtra from "../popups/InventoryExtra";
import Tabs from "../ui/Tabs";
import { v4 as uuidv4 } from 'uuid';
import { drawPicker } from "../popovers/Picker";
import InventoryReserve from "../components/InventoryReserve";
import Cookies from "js-cookie";
import ReportsInventoryList from "../components/ReportsInventoryList";
import { ENUMS } from "../utils/Enums";
import OrderForm from "../components/OrderForm";
import InventoryOrders2 from "../components/InventoryOrders2";
import InventoryOrder, { deleteOrder } from "../components/InventoryOrder";
import InventoryReserveFromStock from "../components/InventoryReserveFromStock";
import ReportsInventorySearch from "../components/ReportsInventorySearch";
import InventoryOrders from "../components/InventoryOrders";
import { ORDER } from "../utils/Struct";
import { getSignal } from "../App";


export const checkSupplierCondition = (_title = "", _supplier = "", callback = () => { }) => {

    showInfo({
        route: window.bm_state.value,
        type: "warning",
        title: "Warning",
        description: <div style={{ "textAlign": "center" }}>
            <div>ISBN {addISBNDashes(_title?.isbn, _title?.condition_code, false)} does not match {_supplier?.supplier} book type "{_supplier?.vendor_type}"</div>
            <div>(eg. Used, Remainer, New)</div>
        </div>,
        callback: callback
    });

}

export default function InventoryController(props) {







    const mode = process.env.REACT_APP_API || 'inherit';
    const { signal = {}, search = false, controller = "", return_search = false, setController = () => { }, is_modal = false, is_global = false, callback = () => { }, route = ROUTES.INVENTORY.INVENTORY } = props;



    const [loading, setLoading] = useState(false);
    const [extrasLoading, setExtrasLoading] = useState(false)


    const defaultFilters = {
        sort: "id",
        limit: 45,
        dynamic: true,
        localSort: "stock_id",
        pubstock: false,
        type: "default"
    };

    const createTab = (_id, _label = "New Tab", _removable = true) => {
        return {
            id: _id,
            label: _label,
            removable: _removable,
            data: [],
            selected: {},
            filters: { ...defaultFilters },
            align: "auto",
            searchMsg: (is_modal) ? "" : "Inventory",
            keywordTerm: false,
            isTitleLink: false
        }
    }

    console.log("MODEL", is_modal)

    const [tabs, setTabs] = useState([
        createTab("default", "Inventory", true)
    ]);

    const [activeTabId, setActiveTabId] = useState("default");
    const activeTabIdRef = useRef("default");
    const activeTab = tabs.find(item => item.id === activeTabId) || tabs[0];


    const data = activeTab?.data || [];
    const selected = activeTab?.selected || {};
    const filters = activeTab?.filters || defaultFilters;
    const align = activeTab?.align || "auto";
    const searchMsg = activeTab?.searchMsg || "";
    const keywordTerm = activeTab?.keywordTerm || false;
    const isTitleLink = activeTab?.isTitleLink || false;

    // const [data, setData] = useState([]);
    // const [selected, setSelected] = useState({});
    // const [filters, setFilters] = useState({ sort: "id", limit: 45, dynamic: true, localSort: "stock_id", pubstock: false, type: "default" });
    // const [align, setAlign] = useState("auto");
    // const [searchMsg, setSearchMsg] = useState((!is_modal) ? "Search results" : "");
    // const keywordTerm = useRef(false);

    const [conditionSelected, setConditionSelected] = useState(false);
    const [fullData, setFullData] = useState({});


    const [gridLoading, setGridLoading] = useState(false);
    const [currentAdjustIndex, setCurrentAdjustIndex] = useState("minimum_onhand");
    const [goto, setGoto] = useState(false)
    const gridType = useRef("");
    const [resetPos, setResetPos] = useState(false);
    const sig = getSignal();
    const stores = sig?.session?.ms_info.filter(item => item.is_splitter_active) ?? [];
    const splitter = (sig?.session?.is_splitter_active && stores?.length > 1);

    const full_view = useRef(false);
    const inventory_pubstock = useRef("min");
    const [reportSearch, setReportSearch] = useState("");


    const inventory_details_ref = useRef();

    const expand = false;

    const history_filters = {
        adjustment: true,
        held: true,
        orders: true,
        orders: true,
        prepay: true,
        quotes: false,
        returns: true,
        sales: true,
        transfers: true
    }
    const [historyFilters, setHistoryFilters] = useState(history_filters);



    const updateActiveTab = (updates) => {
        setTabs(prev =>
            prev.map(item => {
                if (item.id !== activeTabIdRef.current) { return item; }
                const next = typeof updates === "function" ? updates(item) : updates;
                return { ...item, ...next };
            })
        );
    };

    const updateTab = (id, updates) => {
        setTabs(prev =>
            prev.map(item => {
                if (item.id !== id) { return item; }
                const next = typeof updates === "function" ? updates(item) : updates;
                return { ...item, ...next };
            })
        );
    };


    const addTab = (label = "New", values = {}) => {

        if (tabs?.length > 8) {
            showError({ error: "Too many tabs open" });
            return;
        }
        const tab = {
            ...createTab(uuidv4(), label, true),
            ...values
        };

        setTabs(prev => [...prev, tab]);
        setActiveTabId(tab.id);
        activeTabIdRef.current = tab.id;

        return tab.id;
    };

    const activateTab = (tab) => {
        if (!tab) return;

        const stockId = tab?.selected?.stock_id;

        if (
            stockId &&
            String(stockId).substr(0, 8) !== "no-stock"
        ) {
            Cookies.set("inventory_stock_id", stockId);
        }

        activeTabIdRef.current = tab.id;
        setActiveTabId(tab.id);
    };

    const switchTab = id => {
        const tab = tabs.find(item => item.id === id);

        if (!tab) return;

        activateTab(tab);
    };

    const removeTab = id => {
        if (tabs.length === 1) return;

        setTabs(prev => {
            const index = prev.findIndex(item => item.id === id);

            if (index === -1) {
                return prev;
            }

            const next = prev.filter(item => item.id !== id);

            if (activeTabIdRef.current === id) {
                const previous =
                    next[Math.max(0, index - 1)] ||
                    next[0];

                activateTab(previous);
            }

            return next;
        });
    };


    const setData = value => {
        updateActiveTab(prev => ({
            data: typeof value === "function" ? value(prev.data) : value
        }));
    };

    const setSelected = value => {
        updateActiveTab(prev => ({
            selected: typeof value === "function" ? value(prev.selected) : value
        }));
    };

    const setFilters = value => {
        updateActiveTab(prev => ({
            filters: typeof value === "function" ? value(prev.filters) : value
        }));
    };

    const setAlign = value => {
        updateActiveTab({ align: value });
    };

    const setSearchMsg = value => {
        updateActiveTab({ searchMsg: value });
    };

    const setKeywordTerm = value => {
        updateActiveTab({ keywordTerm: value });
    };



    const cycleGridType = () => {

        if (gridLoading) {
            return;
        }

        let _g = gridType.current || "";
        if (_g === "") {
            _g = "weekly";
        } else if (_g === "weekly") {
            _g = "daily";
        } else if (_g === "daily") {
            _g = "monthly";
        } else {
            _g = ""
        }


        gridType.current = _g;
    }






    const drawReportResultsString = () => {
        const { order_1, order_2, order_3, cached_row_total, name = "" } = is_modal;
        const order = [
            order_1 ? getEnumLabel(ENUMS.REPORTS_INDEX, order_1) : "Enter date",
            order_2 && getEnumLabel(ENUMS.REPORTS_INDEX, order_2),
            order_3 && getEnumLabel(ENUMS.REPORTS_INDEX, order_3)
        ].filter(Boolean);

        return (
            <>
                <strong>{name}</strong> | Showing: <span className="text-light">#{selected?.number} of {cached_row_total}</span> records, ordered by <span style={{ color: "var(--text-yellow)" }}>{order.join(", ")}</span>
            </>
        );
    };



    const [state, setState] = useState({
        view: (is_modal) ? "inventory_full" : "inventory",
        edit: false,
        new: false,
        copy: false,
        history_checked: false,
        tabs: "history",
        order: "",
        pubstock: Cookies.get("pubstock_state") || "min"
    })



    useEffect(() => {
        if (state.view === "inventory") {
            full_view.current = false;
            inventory_pubstock.current = state.pubstock;
        }

        if (state.view === "inventory_full") {
            full_view.current = true;
            inventory_pubstock.current = state.pubstock;
        }
    }, [state.view, state.pubstock]);


    const in_stock = (selected?.stock_id && istl(selected)) ? false : true;

    const refs = useRef([])


    const addOrder = () => {
        const event = new CustomEvent("addOrder", { detail: {} });
        window.dispatchEvent(event);
    }


    const switchView = (_state = "inventory", tabs = false, pubstock = state?.pubstock) => {

        if (extrasLoading) {
            return;
        }



        switch (_state) {
            case "inventory":
                window.bm_state.value = route;
                tabs = "inventory"
                pubstock = Cookies.get("pubstock_state") || "";
                break;
            case "inventory_full":
                window.bm_state.value = route;
                break;
            case "history":
                if (!fullData?.history?.rows?.length) {
                    showError({ error: "No history records" })
                    return;
                }
                window.bm_state.value = ROUTES.INVENTORY.HISTORY;
                pubstock = "";
                break;
            case "history_full":
                if (!fullData?.history?.rows?.length) {
                    showError({ error: "No history records" })
                    return;
                }
                _state = "history";
                window.bm_state.value = ROUTES.INVENTORY.HISTORY;
                break;
            case "orders":
                window.bm_state.value = ROUTES.INVENTORY.ORDERS;
                break;
        }




        setState({ ...state, "view": _state, tabs: (tabs) ? tabs : state.tabs, pubstock: pubstock, order: "" })
    };


    const switchEdit = () => {

        // if (window.beta) {
        //     console.log("Edit details disabled for beta");
        //     return;
        // }

        setState(prevState => {
            if (!prevState.edit) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: false,
                copy: false
            };
        });
    };

    const switchNew = () => {
        setState(prevState => {
            if (!prevState.new) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                new: !prevState.new
            };
        });
    };

    const switchCopy = () => {
        setState(prevState => {
            if (!prevState.new) {
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                window.bm_state.value = route;
            }
            return {
                ...prevState,
                edit: !prevState.edit,
                copy: !prevState.copy,
                new: !prevState.new
            };
        });

    }


    const updateRow = (_data, _stock_id, diff = false) => {


        let _d = [...data];
        let _f = _d.findIndex(item => item.stock_id === _stock_id);
        if (_f > -1) {

            if (diff) {
                if (diffObjs(_d[_f], _data, ['available_on_hand', 'on_order', 'price', 'binding', 'title', 'author', 'supplier_1', 'class', 'primary_code', 'pubstock'])) {
                    _d[_f] = _data;
                    setData(_d);
                    setSelected(_data);
                }
            } else {
                _d[_f] = _data;
                setData(_d);
                setSelected(_data);
            }

        }
    }

    useEffect(() => { window.bm_state.value = route }, []);

    const selectedRef = useRef(selected);
    const timeoutRef = useRef(null);
    const pendingRef = useRef(null);
    const lastRunRef = useRef(null);
    const requestIdRef = useRef(0);

    //   adjustment: true,
    //         held: true,
    //         orders: true,
    //         orders: true,
    //         prepay: true,
    //         quotes: false,
    //         returns: true,
    //         sales: true,
    //         transfers: true


    const runFetch = useCallback((_selected, extras = { want_other_conditions: true, want_pending_orders: true, want_pubstock: true, want_history: true }) => {
        const id = ++requestIdRef.current;
        setGridLoading(true);
        pubCall("stock.getSingleExtras", {
            stock_id: _selected.stock_id,
            grid_type: gridType.current,
            want_other_conditions: extras?.want_other_conditions,
            want_pending_orders: extras?.want_pending_orders,
            want_pubstock: extras?.want_pubstock,
            want_history: extras?.want_pubstock,
            only_recent: true,
            adjustment: historyFilters.adjustment,
            held: historyFilters.held,
            orders: historyFilters.orders,
            prepay: historyFilters.prepay,
            quotes: historyFilters.quotes,
            returns: historyFilters.returns,
            transfers: historyFilters.transfers,
            sales: historyFilters.sales
        }, (_s, _r) => {
            if (id !== requestIdRef.current) {
                setExtrasLoading(false);
                return;
            };
            setExtrasLoading(false);
            setGridLoading(false);
            if (_s) {
                if (!extras) {
                    setFullData({ ...fullData, "grid_info": _r.grid_info, "monthly_sold": _r.monthly_sold })
                }

                if (_selected?.title_link) {

                    _r.stock.title_link = { ..._selected.title_link };
                    setData(prev => prev.map(item => item.stock_id === _r.stock.stock_id ? { ...item, ..._r.stock } : item));
                    setFullData(_r);
                    return;
                } else {
                    setFullData(_r);
                }




                if (_r?.stock) {
                    setData(prev => prev.map(item => item.stock_id === _r.stock.stock_id ? { ...item, ..._r.stock } : item));
                } else {

                }
            } else {
                showError(_r);
            }
        }
        );
    }, [historyFilters]);

    const fetchExtra = useCallback((_selected = selected) => {



        setFullData({});
        selectedRef.current = _selected;
        setConditionSelected(false);


        // don't fetch if no stock id
        if (!_selected?.stock_id || _selected.stock_id.substr(0, 8) === "no-stock") {

            const stock = {
                ..._selected.title_link,
                stock_id: _selected.stock_id,
                title_link: { ..._selected.title_link }
            };

            // Fill stock/title_link immediately
            setFullData({
                stock
            });

            if (!_selected?.title_link?.primary_code) {
                return;
            }

            pendingRef.current = _selected;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }



            timeoutRef.current = setTimeout(() => {
                const toRun = pendingRef.current;
                const id = ++requestIdRef.current;

                if (!toRun?.title_link?.primary_code) return;

                setExtrasLoading(true);

                pubCall(
                    "title.getPubstock",
                    { primary_code: toRun.title_link.primary_code },
                    (_s, _r) => {
                        if (id !== requestIdRef.current) return;

                        if (_s) {
                            setFullData(prev => ({
                                ...prev,
                                pubstock: _r
                            }));
                        }

                        setExtrasLoading(false);
                    }
                );

                timeoutRef.current = null;
                pendingRef.current = null;
            }, 300);

            return;
        }

        Cookies.set("inventory_stock_id", _selected.stock_id);
        if (!timeoutRef.current) {
            setExtrasLoading(true);
            runFetch(_selected);
            lastRunRef.current = _selected;
        }
        pendingRef.current = _selected;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            const toRun = pendingRef.current;
            if (toRun && toRun.stock_id !== lastRunRef.current?.stock_id) {
                setExtrasLoading(true);
                runFetch(toRun);
                lastRunRef.current = toRun;
            }
            timeoutRef.current = null;
            pendingRef.current = null;
        }, 300);
    }, [selected, runFetch]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);


    useEffect(fetchExtra, [selected])


    const fetchKeywordNext = (e) => {

        if (!keywordTerm === false) {
            return;
        }
        pubCall("stock.searchKeyword", { limit: 45, offset: data.length, keyword: keywordTerm }, (_s, _r) => {
            if (_s) {
                let _combined = data.concat(_r.rows);
                if (_r.rows.length < 45 || _combined.length === _r.total) {
                    keywordTerm = false;
                }
                setData(data.concat(_r.rows));
            }
        })
    }

    useEffect(() => {
        const onExtra = (e) => { fetchExtra(); };
        const onKewordNext = (e) => { fetchKeywordNext(e.detail) }
        window.addEventListener("callKeywordNext", onKewordNext);
        window.addEventListener("callExtra", onExtra);
        return () => {
            window.removeEventListener("callKeywordNext", onKewordNext)
            window.removeEventListener("callExtra", onExtra)
        };
    }, [selected, data]);

    const showMessageNote = () => {
        window.bm_state.value = ROUTES.INVENTORY.MESSAGE;
        createModal({ component: <InventoryMessage controller={controller} stock_id={selected?.stock_id} route={ROUTES.INVENTORY.MESSAGE} />, closable: true, title: "Inventory Message", callback: () => { window.bm_state.value = route; } })
    }


    useEffect(() => {

        if (search) {
            onSearch(search?.results, search?.message)
        }

    }, [])

    const onSearch = (e, _searchMs, _full_view = false) => {


        const { type = "", message = "", term = "", new_tab = false } = (e) ? e : {};
        window.skip_inventory_fetch = true;

        if (_full_view) {
            // open full for series...
            switchView("inventory_full")
        }



        switch (type.toLowerCase()) {



            case "title_link":
                const _title_link = {
                    keywordTerm: term,
                    align: "start",
                    isTitleLink: true,
                    data: e.data,
                    filters: {
                        ...defaultFilters,
                        dynamic: false,
                        type: "title_link"
                    },
                    selected: e.data.length > 0 ? e.data[0] : {},
                    searchMsg: message || _searchMs || "Titlelink Results"
                }


                if (new_tab) {
                    addTab(_title_link.searchMsg, _title_link)
                } else {
                    updateActiveTab(_title_link);
                }


                // setAlign("start");
                // setFilters({ ...filters, "dynamic": false, type: "title_link" })
                // setData(e.data);
                // setSelected(e.data.length > 0 ? e.data[0] : {});
                // setIsTitleLink(true);
                break;

            case "keyword":


                const _keyword = {
                    keywordTerm: term,
                    align: "start",
                    isTitleLink: false,
                    data: e.data.rows,
                    filters: {
                        ...defaultFilters,
                        dynamic: false,
                        sort: "id",
                        localSort: "init",
                        type: "keyword"
                    },
                    selected: e.data.rows[0] || {},
                    searchMsg: message || _searchMs || "Keyword Results"
                }

                if (new_tab) {
                    addTab(_keyword.searchMsg, _keyword)
                } else {
                    updateActiveTab(_keyword);
                }

                // setKeywordTerm(term);
                // setFilters({ ...filters, "dynamic": false, "sort": "id", localSort: "init", type: "keyword" })
                // setData(e.data.rows);
                // setSelected(e.data.rows.length > 0 ? e.data.rows[0] : {})
                break;
            case "title":
            case "isbn":
            case "author":
            case "supplier":
            case "class":
            case "upc":



                const _results = {
                    keywordTerm: term,
                    align: "start",
                    isTitleLink: false,
                    data: e.data.rows_previous.concat(e.data.rows_next),
                    filters: {
                        ...defaultFilters,
                        dynamic: true,
                        sort: type.toLowerCase(),
                        localSort: "init",
                        type: type.toLowerCase()
                    },
                    selected: (e.data.rows_next.length > 0) ? e.data.rows_next[0] : {},
                    searchMsg: message || _searchMs || "Search Results"
                }

                if (new_tab) {
                    addTab(_results.searchMsg, _results)
                } else {
                    updateActiveTab(_results);
                }

                // if (e.data.rows_previous.length > 0) { setAlign("start"); }
                // setFilters({ ...filters, "sort": "isbn", "dynamic": true, type: "isbn" })
                // setData(e.data.rows_previous.concat(e.data.rows_next));
                // setSelected((e.data.rows_next.length > 0) ? e.data.rows_next[0] : {})
                break;

        }

        setResetPos(!resetPos)
        setLoading(false)

    }

    const showReportSearch = () => {
        window.bm_state.value = ROUTES.REPORTS.SEARCH;
        createModal({
            component: <ReportsInventorySearch setReportSearch={setReportSearch} controller={controller} route={ROUTES.REPORTS.SEARCH} />, closable: true, title: "Search",
            callback: (e) => {
                window.bm_state.value = route
            }
        });
    }

    const showSearch = () => {
        window.bm_state.value = ROUTES.INVENTORY.SEARCH;
        createModal({
            component: <InventorySearch controller={controller} setSelected={setSelected} setStock={setSelected} selected={selected} route={ROUTES.INVENTORY.SEARCH} />, closable: true, title: "Product Search",
            callback: (e, _searchMsg) => {
                if (e) {
                    onSearch(e, _searchMsg);
                }
                window.bm_state.value = route
            }
        });
    }

    const showSort = () => {
        window.bm_state.value = ROUTES.INVENTORY.SORT;
        createModal({
            component: <InventoryIndex sort={filters.sort} route={ROUTES.INVENTORY.SORT} />, closable: true, title: "Sort",
            callback: (_sort) => {
                window.bm_state.value = route;
                if (_sort) { setFilters({ ...filters, "sort": _sort, "dynamic": true }); }
            }
        });
    }


    const drawReserve = () => {

        drawPicker({
            controller: controller,
            value: "Pend", title: "Reserve for customer", closeable: true, show_keys: true, allow_keys: true, height: 300, route: route, close: () => { }, callback: (e) => {
                if (e) {
                    if (e === "inventory") {
                        // Pull from Inventory
                        if (!selected?.available_on_hand) {
                            if (Cookies.get("hold_without_inventory")) {
                                // Bypass...
                                showReserveFromStock();
                                return;
                            } else {
                                showMessage("[TODO] - REQUIRES POS")
                                return;
                            }
                        } else {
                        }
                    } else {
                        // Special Order
                        setState({ ...state, view: "orders", tabs: "reserve", pubstock: "" })
                    }
                }
            }, offset: [0, 10],
            options: [
                { value: "special_order", label: "Order: Special order it for customer", key: KBD.O },
                { value: "inventory", label: (selected?.available_on_hand) ? `Inventory: Grab it from  ${selected?.available_on_hand} copies on the shelf` : "No copies available on hand (order instead?)", key: KBD.I }
            ]
        })
    }

    const pickReserve = () => {


        if (!selected?.primary_code && selected?.title_link) {
            showConfirm({
                controller: controller,
                route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Title doesn't exist<br /><div className="shim" />Create new inventory record?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                    if (_key) {
                        inventory_details_ref?.current?.editTitle({ ...selected, title_link: { ...selected.title_link } }, (_r) => {
                            let _data = [...data];
                            let _index = _data.findIndex(item => item.stock_id == selected?.stock_id);
                            _data[_index] = _r;
                            setData(_data)
                            setSelected({ ..._data[_index], "new_from_titlelink": true });
                            setTimeout(() => {
                                drawReserve()
                            }, 50)
                        })
                    }
                }
            })
            return;
        }

        drawReserve();

    }


    const showReserveFromStock = () => {

        window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        createModal({
            component: <InventoryReserveFromStock
                updateSellPrice={updateSellPrice}
                fetchExtra={fetchExtra}
                controller={controller}
                signal={signal}
                switchView={switchView}
                sell_price={fullData?.stock?.price}
                setFullData={setFullData}
                fullData={fullData}
                callback={() => {

                    switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);


                }}
                primary_code={selected?.primary_code}
                condition_code={selected?.condition_code} />,
            closable: true,
            title: "Inventory Reservation (Pull Stock for Customer)",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });

    }

    const showReserve = () => {

        window.bm_state.value = ROUTES.INVENTORY.RESERVE;
        createModal({
            component: <InventoryReserve
                updateSellPrice={updateSellPrice}
                fetchExtra={fetchExtra}
                controller={controller}
                signal={signal}
                switchView={switchView}
                sell_price={fullData?.stock?.price}
                setFullData={setFullData}
                fullData={fullData}
                callback={() => {
                    switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);
                }}
                primary_code={selected?.primary_code}
                condition_code={selected?.condition_code} />,
            closable: true,
            title: "New Customer Order or Pull From an Existing Order ",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });

    }

    const showExtra = () => {
        window.bm_state.value = ROUTES.INVENTORY.EXTRA;
        createModal({
            component: <InventoryExtra signal={signal} route={ROUTES.INVENTORY.EXTRA} />, closable: true, title: "Xtra Options",
            callback: (_type) => {
                window.bm_state.value = route;
            }
        });
    }


    const close = () => {

        // Close title link...
        if (isTitleLink) {

            setFilters({ ...filters, "dynamic": true });
        } else {
            // Close inventory...
            alert("close")
        }

    }




    const showAdjust = () => {
        window.bm_state.value = ROUTES.INVENTORY.ADJUST;
        createModal({
            component: <InventoryAdjust signal={signal} stock_data={selected} currentAdjustIndex={currentAdjustIndex} setCurrentAdjustIndex={setCurrentAdjustIndex} sort={filters.sort} route={ROUTES.INVENTORY.ADJUST} />, closable: true, title: "Adjust Quantities / Keywords ",
            callback: (_stock) => {
                if (_stock) {
                    updateRow(_stock, _stock.stock_id);
                }
                window.bm_state.value = route;
            }
        });
    }


    const togglePubstock = (_set = null) => {
        const hasPubstock = fullData?.pubstock?.length > 0;

        let next;

        if (_set !== null) {
            next = _set;
        } else if (!hasPubstock) {
            next = state.pubstock ? "" : "min";
        } else if (state.pubstock === "") {
            next = "min";
        } else if (state.pubstock === "min") {
            next = "full";
        } else {
            next = "";
        }

        if (state.view === "inventory" && state.pubstock !== "full") {
            Cookies.set("pubstock_state", next);
        }

        setState(prev => ({
            ...prev,
            pubstock: next
        }));
    };
    const deleteRow = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Delete Inventory Card?"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("stock.delete", { stock_id: selected.stock_id }, (_s, _r) => {
                        if (_s) {
                            // shift selected down, or up
                            let _f = data.findIndex(item => item.stock_id === selected.stock_id);
                            if (data.length > _f - 1) { setSelected(data[_f + 1]); }
                            else if (data.length > 0) { setSelected(data[_f - 1]); }
                            else { setSelected({}) }
                            // remove from data
                            setData(data.filter(item => item.stock_id !== selected.stock_id));
                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }


    const sendToApp = () => {

        if (!selected?.primary_code) return;

        const remembered_station = (Cookies.get("remembered_station")) ? Cookies.get("remembered_station") : getSignal()?.session?.station.toString() || "";
        const remembered_send_option = (Cookies.get("remembered_send_option")) ? Cookies.get("remembered_send_option") : "biz";

        const move_to_top = (remembered_send_option === "bm2") ? "bm" : remembered_send_option;
        const send_options = moveItemToTopByKey([
            { value: "biz", label: `biz.bookmanager.com (for ISBN ${selected?.primary_code})`, key: KBD.W },
            { value: "web", label: `Your consumer webstore (for ISBN ${selected?.primary_code})`, key: KBD.C },
            { value: "bm", label: `Bookmanager software on station ${remembered_station}`, key: KBD.B },
            { value: "bm2", label: `Bookmanager software on another station...`, key: KBD.S }
        ], "value", move_to_top)

        drawPicker({
            controller: controller,
            value: "Pend", title: "Send to...", closeable: true, show_keys: true, allow_keys: true, height: 300, route: route, close: () => { }, callback: (e, f) => {
                if (e) {

                    Cookies.set("remembered_send_option", e);

                    switch (e) {
                        case "biz":
                            window.open(`https://biz.bookmanager.com/purchasing/browse/filter/t/${selected?.primary_code}`);
                            showMessage("Sent!");
                            break;
                        case "bm":
                            pubCall("stock.sendToBmStation", { message: "New message", station: parseInt(remembered_station), stock_id: selected?.stock_id }, (_s, _r) => {
                                if (_s) {
                                    showMessage("Sent!");
                                } else { showError(_r) }
                            })
                            break;
                        case "bm2":
                            setTimeout(() => {
                                requestPrompt({
                                    route: route, button: true, width: 0, title: "Station", value: parseInt(remembered_station), inputProps: { number: true, maxLength: 2, placeholder: "##", style: { "textAlign": "left" }, width: 30 }, width: 113, callback: (e) => {
                                        if (e) {
                                            pubCall("stock.sendToBmStation", { message: "New message", station: e, stock_id: selected?.stock_id }, (_s, _r) => {
                                                if (_s) {
                                                    Cookies.set("remembered_station", e)
                                                    showMessage("Sent!");
                                                } else { showError(_r) }
                                            })
                                        }
                                    }
                                })
                            }, 10)
                            break;
                        case "web":
                            window.open(window.customer_url + `browse/filter/t/${selected?.primary_code}/k/keyword`)
                        default:
                            break;
                    }
                }
            }, offset: [0, 10],
            options: send_options
        })
    }

    const showWeb = () => {
        if (selected?.primary_code) {
            window.open(`https://biz.bookmanager.com/purchasing/browse/filter/t/${selected?.primary_code}`)
        }
    }

    const showGoto = () => {

        requestPrompt({
            route: route, width: 0, title: "Go to Record #", inputProps: { number: true, style: { "textAlign": "left" }, width: 100 }, width: 182, callback: (e) => {
                if (e) {
                    if (is_modal?.cached_row_total) {
                        if (is_modal?.cached_row_total < parseInt(e)) {
                            setGoto(parseInt(is_modal?.cached_row_total));

                            return;
                        }
                    }
                    setGoto(e);
                }
            }
        })
    }



    const updateGridInfo = () => {
        // weekly, daily
        const grid_type = (gridType.current) ? gridType.current : "";

        if (grid_type === "monthly") {

            pubCall("stock.getMonthlySold", { primary_code: selected?.primary_code, condition_code: selected?.condition_code }, (_s, _r) => {
                if (_s) {
                    setFullData(prev => ({
                        ...prev,
                        monthly_sold: _r,
                        grid_info: null
                    }));
                }
                setGridLoading(false)
            })


            return;
        }

        if (grid_type) {
            setGridLoading(true)
            pubCall("stock.getGridInfo", { primary_code: selected?.primary_code, condition_code: selected?.condition_code, grid_type: gridType.current }, (_s, _r) => {
                if (_s) {
                    setFullData(prev => ({
                        ...prev,
                        grid_info: _r,
                        monthly_sold: null,
                    }));
                }
                setGridLoading(false)
            })
        } else {
            setFullData(prev => ({
                ...prev,
                grid_info: null,
                monthly_sold: null,
            }));
        }
    }


    const createOrder = () => {



        if (!selected?.primary_code && selected?.title_link) {
            showConfirm({
                controller: controller,
                route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Title doesn't exist<br /><div className="shim" />Create new inventory record?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                    if (_key) {
                        inventory_details_ref?.current?.editTitle({ ...selected, title_link: { ...selected.title_link } }, (_r) => {
                            let _data = [...data];
                            let _index = _data.findIndex(item => item.stock_id == selected?.stock_id);
                            _data[_index] = _r;
                            setData(_data)
                            setSelected({ ..._data[_index], "new_from_titlelink": true });
                            setTimeout(() => {
                                setState({ ...state, view: "orders", tabs: "orders", pubstock: "" })
                            }, 50)
                        })
                    }
                }
            })
            return;
        }

        setState({ ...state, view: "orders", tabs: "orders", pubstock: "" })

    }



    const inventory_nav = [

        {
            key: KBD.ESCAPE, action: () => {
                if (is_modal || is_global) {
                    callback();
                } else {
                    setController("home")
                }
            }
        },


        {
            key: KBD.ENTER, action: () => {
                if (return_search) {
                    callback({ ...selected });
                }

                if (state.view === "inventory_full") { switchView("inventory") } else { switchView("inventory_full") }
            }
        },

        { key: KBD.SLASH, action: () => { { cycleGridType(); updateGridInfo() } } },
        { key: KBD.TAB, action: () => switchView("history", "history") },
        { key: KBD.SPACE, action: () => { inventory_details_ref?.current?.toggleCover?.(); } },
        { disabled: (window.beta), key: KBD.A, text: "Adj", action: () => (window.beta) ? "" : showAdjust() },
        { disabled: (window.beta), key: KBD.C, text: "Cpy", action: () => (window.beta) ? "" : switchCopy() },
        { disabled: (window.beta), key: KBD.D, text: "Del", action: () => (window.beta) ? "" : deleteRow() },
        { key: KBD.ARROW_RIGHT, action: () => { (state.view === "inventory_full") ? switchView("inventory") : switchView("history", "history") } },
        { key: KBD.ARROW_LEFT, action: () => switchView("inventory_full") },
        { key: KBD.E, text: "Edt", action: () => switchEdit() },
        { key: KBD.H, text: "Hst", action: () => switchView("history", "history") },
        { disabled: (window.beta), key: KBD.I, text: "Indx", action: () => (window.beta) ? "" : showSort() },
        {
            key: KBD.L, text: "Lbl", action: () => {
                if (state.pubstock == "min" || state.pubstock === "") {
                    showMessage("TODO Label")
                }
            }
        },


        { disabled: (window.beta), key: KBD.M, text: "Msg", action: () => (window.beta) ? "" : showMessageNote() },
        { disabled: (window.beta), key: KBD.N, text: "New", action: () => (window.beta) ? "" : switchNew() },
        {
            key: KBD.O, text: "Ord", action: () => createOrder()
        },
        { disabled: (window.beta), key: KBD.R, text: "Rsv", action: () => (window.beta) ? "" : pickReserve() },
        { key: KBD.S, text: "Srch", action: () => { showSearch() } },
        { key: KBD.F2, action: () => { showSearch() } },
        { text: "Trf" },
        { key: KBD.V, text: "View", action: () => switchView("history", "history") },
        { key: KBD.W, text: "Web", action: sendToApp },
        { disabled: (window.beta), key: KBD.X, text: "Xtra", action: () => (window.beta) ? "" : showExtra() },
        { text: "Ytag" },
        // {
        //     key: KBD.T,
        //     text: "Test", action: () => {
        //         runEvent("callOrder", { test: "test" }, (e) => {
        //             alert(e)
        //         })
        //     }
        // },

        { key: KBD.COMMA, text: ", Pubstock", right: true, action: () => togglePubstock() },
        // { text: ". Multistore", right: true },

        { key: KBD.Digit0, action: () => { setController("reports") } },
        { key: KBD.SPACE, action: () => { } },

    ]

    const reports_nav = [
        { key: KBD.ESCAPE, action: () => { callback() } },
        { key: KBD.ENTER, action: () => (state.view === "inventory_full") ? switchView("inventory") : switchView("inventory_full") },
        { key: KBD.SLASH, action: () => { { cycleGridType(); runFetch(selected) } } },
        { key: KBD.TAB, action: () => switchView("history", "history") },
        { key: KBD.SPACE, action: () => { inventory_details_ref?.current?.toggleCover?.(); } },
        { disabled: (window.beta), key: KBD.A, text: "Adj", action: () => (window.beta) ? "" : showAdjust() },
        { key: KBD.G, text: "Go to", action: () => { showGoto() } },
        { disabled: (window.beta), key: KBD.D, text: "Del", action: () => (window.beta) ? "" : deleteRow() },
        { disabled: (window.beta), key: KBD.E, text: "Edt", action: () => (window.beta) ? "" : switchEdit() },
        { key: KBD.ARROW_RIGHT, action: () => { (state.view === "inventory_full") ? switchView("inventory") : switchView("history", "history") } },
        { key: KBD.ARROW_LEFT, action: () => switchView("inventory_full") },
        { key: KBD.H, text: "Hst", action: () => switchView("history", "history") },
        { text: "Lbl" },
        { disabled: (window.beta), key: KBD.M, text: "Msg", action: () => (window.beta) ? "" : showMessageNote() },
        { key: KBD.O, text: "Ord", action: () => { setState({ ...state, view: "orders", tabs: "orders", pubstock: "" }) } },
        { key: KBD.P, text: "Print / Export", action: () => { props.showPrintExport() } },
        { text: "Qsls" },
        { disabled: (window.beta), key: KBD.R, text: "Rsv", action: () => (window.beta) ? "" : pickReserve() },
        {
            key: KBD.S, text: "Srch", action: () => {

                showReportSearch()

            }
        },
        {
            key: KBD.F2, action: () => {
                setTimeout(() => { kbdEvent(KBD.S) }, 100)
                setController("inventory");
            }
        },
        { text: "Ttl" },
        { text: "View" },
        { key: KBD.W, text: "Web", action: sendToApp },
        { disabled: (window.beta), key: KBD.X, text: "Xtra", action: () => (window.beta) ? "" : showExtra() },
        { text: "Ytag" },
        { text: "Zrtn" },

        { key: KBD.COMMA, text: ", Pubstock", right: true, action: () => togglePubstock() },

        {
            key: KBD.Digit2, action: () => {

                window.inventory_refresh = !window.inventory_refresh;
                setController("inventory")
            }
        }
    ]

    const nav = (is_modal) ? reports_nav : inventory_nav;


    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [], [KBD.F2], [], null);
        return cleanup;
    }, [nav, state])


    const getStockData = () => {

        if (state.new) {

            if (state.copy) {
                return { ...selected, "stock_id": "" }
            }

            return { ...stock_structure }
        }
        if (selected) {

            if (conditionSelected) {
                return conditionSelected?.stock;
            }

            if (!in_stock) {
                return { ...selected.title_link, stock_id: selected.stock_id }
            } else {
                if (fullData.stock?.stock_id === selected?.stock_id) {
                    return fullData.stock;
                }
                return { ...selected }
            }
        } else {
            return {}
        }
    }

    const filterLocal = (_data, _filters = filters) => {

        if (_filters.dynamic) {
            return _data;
        } else {
            return _data;

            let _s = _filters.localSort;
            return _data.sort((a, b) => {
                if (a[_s] < b[_s]) {
                    return -1;
                }
                if (a[_s] > b[_s]) {
                    return 1;
                }
                return 0;
            })
        }
    }


    const toggleHistory = () => {
        setState(prev => ({
            ...prev,
            history_checked: !prev.history_checked
        }));
    };

    const handleTabChange = (tabId) => {

        let _view = state.view;



        if (tabId === "history" && window.bm_state.value === ROUTES.INVENTORY.ORDERS) {
            switchView("inventory")
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }
        else if (tabId === "orders" && window.bm_state.value === ROUTES.INVENTORY.HISTORY) {
            switchView("inventory")
        }
        else {
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }


    };


    const updateSellPrice = (_sell_price) => {

        const _stock_data = { ...fullData.stock, "price": parseFloat(_sell_price) }
        pubCall("stock.edit", { stock: _stock_data }, (_s, _r) => {
            if (_s) {
                setFullData({ ...fullData, "stock": _r });
                showMessage("Stock price updated.")
            } else {
                showError(_r.error)
            }
        })

    }


    const getOrderDataFromHistoryItem = (_history_item, callback = () => { }) => {
        pubCall("order.getInfo", { order_id: _history_item?.history_id }, (_s, _r) => {
            callback(_s, _r)
        })
    }

    const editOrder = (_history_item, read_only = false) => {

        if (_history_item.table !== "order") {
            return;
        }
        if (!_history_item?.history_id) {
            showError({ error: "There was an error" })
            return;
        }

        getOrderDataFromHistoryItem(_history_item, (_s, _r) => {
            if (_s) {
                if (read_only) {
                    if (state?.order?.order?.order_id === _r?.order_id) {
                        setState({
                            ...state, tabs: "history", order: ""
                        })
                    } else {
                        setState({
                            ...state, tabs: "read-only", pubstock: "", order: {
                                quantity: _r?.quantity,
                                order: _r,
                                reserveFromOrder: false,
                            }
                        })
                    }
                    return;
                } else {
                    window.bm_state.value = ROUTES.INVENTORY.ORDER;
                    setState({
                        ...state, view: "order", pubstock: "full", order: {
                            quantity: _r?.quantity,
                            order: _r,
                            reserveFromOrder: false,
                        }
                    })
                }
                return;
            } else {
                showError(_r);
            }
        })


    }

    const tabData = [
        {
            id: "history", label: <>History</>, content:
                <div style={{ "height": "calc(100vh - 451px)", minHeight: "200px", "display": "flex", "flexDirection": "column" }}>
                    <div style={{ "flex": "1", "width": "610px" }}>
                        <InventoryHistory
                            controller={controller}
                            filters={historyFilters}
                            setFilters={setHistoryFilters}
                            onSelectSupplier={(e) => editOrder(e)}
                            togglePubstock={togglePubstock}
                            loading={extrasLoading}
                            fullData={fullData}
                            history={fullData?.history}
                            in_stock={in_stock}
                            route={ROUTES.INVENTORY.HISTORY}
                            view={state.view}
                            switchView={switchView}
                            selected={selected}
                            data={[]}
                        />
                    </div>
                </div>
        },
        {
            id: "orders", label: <>Order</>, content:
                <div style={{ "height": "calc(100vh - 451px)", minHeight: "200px", "display": "flex", "flexDirection": "column" }}>
                    <div style={{ "flex": "1", "width": "610px", "backgroundColor": "var(--card-bg)" }}>


                        <InventoryOrders2

                            controller={controller}
                            fetchExtra={fetchExtra}
                            updateSellPrice={updateSellPrice}
                            conditionSelected={conditionSelected}
                            setConditionSelected={setConditionSelected}
                            togglePubstock={togglePubstock}
                            filters={filters}
                            setFilters={setFilters}
                            setSelected={setSelected}
                            loading={extrasLoading}
                            other_conditions={fullData.other_conditions}
                            selected={selected}
                            setFullData={setFullData}
                            getExt
                            fullData={fullData}
                            signal={signal}
                            cost={fullData?.stock?.cost}
                            sell_price={fullData?.stock?.price}
                            state={state}
                            pending_orders={fullData.pending_orders}
                            switchView={switchView}
                            route={ROUTES.INVENTORY.ORDERS}
                            pubstock={<InventoryPubstock
                                onSelectSupplier={(e) => {
                                    addAdditive(e)
                                }}
                                controller={controller}
                                is_order
                                conditionSelected={conditionSelected}
                                setConditionSelected={setConditionSelected}
                                other_conditions={fullData.other_conditions}
                                setState={(e) => togglePubstock(e)}
                                state={state.pubstock}
                                pending_orders={fullData.pending_orders}
                                loading={extrasLoading}
                                pubstock={fullData?.pubstock}
                                selected={selected}
                            />}
                        />


                    </div>
                </div>
        },
    ];


    const pendingQty = useRef(0);
    const lastItem = useRef(null);
    const timer = useRef(null);


    const sendAdditive = (_group = "", _stock = selected) => {
        if (!lastItem.current) return;
        let _template = {
            ...ORDER,
            primary_code: _stock?.primary_code,
            condition_code: _stock?.condition_code,
            sell_price: _stock?.sell_price,
            quantity: pendingQty.current
        };

        const _pubstock = lastItem.current;

        if (_pubstock?.supplier && _pubstock.supplier.length === 5) {
            _template.supplier = _pubstock.supplier.slice(0, 3);
        } else {
            _template.supplier = _pubstock?.supplier;
        }

        _template.invoice_price = parseFloat(_pubstock.supplier_price);
        _template.supplier_discount = convertDiscountToInt(_pubstock.discount);

        if (_group) {
            _template.order_separator = _group;
        }

        const pos = [window.mouse[0] - 40, window.mouse[1] - 50];

        pubCall(
            "order.additiveItem",
            { order_item: _template, require_clerk_code: true },
            (_s, _r) => {
                if (_s) {
                    showMessage("Order added", 2000, "toast", pos);
                    fetchExtra(_stock);
                } else {
                    showError(_r);
                }
            }
        );

        // reset
        pendingQty.current = 0;
        lastItem.current = null;
    };



    const addAdditive = (_pubstock, _group = "", _stock = selected) => {
        pendingQty.current += 1;
        lastItem.current = _pubstock;

        const pos = [window.mouse[0] - 10, window.mouse[1] - 50];
        showMessage(pendingQty.current, 2000, "toast", pos);


        if (timer.current) {
            clearTimeout(timer.current);
        }

        timer.current = setTimeout(() => {
            sendAdditive(_group, _stock);
        }, 300);
    };


    const drawTabs = () => {

        return (
            <div className="ui-table-tabs">
                {tabs.map(item => {
                    return (
                        <div key={item.id} onClick={(e) => { e.preventDefault(); e.stopPropagation(); switchTab(item.id) }} className={(item.id === activeTabId) ? "ui-table-tab ui-table-tab-active" : "ui-table-tab"}>
                            <small>{item.searchMsg}</small>
                            {(tabs?.length > 1 &&
                                <button
                                    className="ui-table-tab-close"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        removeTab(item.id);
                                    }}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    )
                })}

            </div>
        )
    }


    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>
                <OrderForm />
                <div style={{ pointerEvents: (state?.view === "orders" || state?.view === "order") ? "none" : "auto" }} className={(state?.view === "orders" || state?.view === "order") ? "desaturate" : ""}>
                    <InventoryDetails
                        onSearch={onSearch}
                        ref={inventory_details_ref}
                        controller={controller}
                        state={state}
                        gridLoading={gridLoading}
                        setState={setState}
                        setSelected={(e) => {
                            setSelected({ ...selected, ...e })
                        }}
                        gridType={gridType} monthly_sold={fullData?.monthly_sold} grid_info={fullData?.grid_info} signal={signal} in_stock={in_stock}
                        setData={setData} isTitleLink={isTitleLink}
                        updateRow={updateRow}
                        cover_key={fullData?.cover_key || ""}
                        switchEdit={switchEdit}
                        isnew={state.new}
                        edit={state.edit}
                        stock_data={getStockData()}
                    /></div>
                <div onDoubleClick={() => state.edit && kbdEvent(KBD.ESCAPE)}>
                    <div className={(state.edit) ? "dim-overlay" : ""}>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        {(state.view === "reserve" && <div>
                            <InventoryReserve
                                fetchExtra={fetchExtra}
                                controller={controller}
                                signal={signal}
                                switchView={switchView}
                                sell_price={fullData?.stock?.price}
                                setFullData={setFullData}
                                fullData={fullData}
                                callback={() => {
                                    switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);
                                }} primary_code={selected?.primary_code} condition_code={selected?.condition_code} />

                        </div>)}

                        {(state.view !== "reserve" &&
                            <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={(is_modal && state.tabs === "expand") ? 0 : 15}>

                                {

                                    <>
                                        {/* READ ONLY */}


                                        {(state.view === "orders" && <>

                                            <InventoryOrders
                                                setState={setState}
                                                state={state}
                                                togglePubstock={togglePubstock}
                                                controller={controller}
                                                tab={state?.tabs}
                                                switchView={switchView}
                                                updateSellPrice={updateSellPrice}
                                                fetchExtra={fetchExtra}
                                                signal={signal}
                                                sell_price={fullData?.stock?.price}
                                                setFullData={setFullData}
                                                fullData={fullData}
                                                callback={() => {
                                                    switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);
                                                    fetchExtra();
                                                }}
                                                primary_code={selected?.primary_code}
                                                condition_code={selected?.condition_code}

                                            />

                                        </>)}

                                        {((state.view === "history" && state.tabs === "read-only") || state.view === "order") && <>

                                            <div
                                                style={{
                                                    width: "100%",
                                                    position: "relative",
                                                    marginTop: (splitter) ? "max(-292px, min(calc(100vh - 942px),0px))" : "max(-252px, min(calc(100vh - 902px),0px))",
                                                    minHeight: "400px",
                                                    height: "calc(calc(100vh - 440px) - min(0px, calc(100vh - 650px)))",
                                                }}
                                            >
                                                <InventoryOrder
                                                    route={ROUTES.INVENTORY.ORDER}
                                                    updateSellPrice={updateSellPrice}
                                                    onSave={(e) => {
                                                        fetchExtra();
                                                        switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);
                                                    }}
                                                    onExit={() => {

                                                        switchView(full_view.current ? "inventory_full" : "inventory", "inventory", inventory_pubstock.current);
                                                    }}
                                                    onEdit={() => {
                                                        window.bm_state.value = ROUTES.INVENTORY.ORDER;
                                                        setState({ ...state, view: "order", tabs: "", pubstock: "full" })
                                                    }}
                                                    onRemove={() => { }}
                                                    customerRequired={state?.order?.customerRequired}
                                                    fullData={fullData || {}}
                                                    controller={controller}
                                                    order={{ ...state?.order?.order, quantity: parseInt(state?.order?.quantity) }}
                                                    full={true}
                                                    sell_price={fullData?.stock?.price}
                                                    edit={(state.view === "order")}
                                                    reserveFromOrder={state?.order?.reserveFromOrder}
                                                    pubstock={true}
                                                    new_from_titlelink={selected?.new_from_titlelink}
                                                />

                                            </div>

                                        </>}


                                        {(is_modal) &&
                                            <ReportsInventoryList
                                                showPrintExport={props.showPrintExport}
                                                hide={(state?.tabs === "read-only" || state?.view === "orders" || state?.view === "order")}
                                                reportSearch={reportSearch}
                                                controller={controller}
                                                header={<>{searchMsg}{(is_modal && !searchMsg && drawReportResultsString())}</>}
                                                report={is_modal}
                                                onSelectedRowClick={() => {
                                                    if (state?.view === "inventory" || state?.view === "inventory_full") {
                                                        kbdEvent(KBD.ENTER)
                                                    }
                                                }}

                                                switchView={switchView}
                                                selected={selected}
                                                setSelected={setSelected}
                                                route={route}
                                                state={state}
                                                setState={setState}
                                                fullData={fullData}
                                                goto={goto}
                                            />
                                        }


                                        {(!is_modal) &&
                                            <InventoryList

                                                resetPos={resetPos}
                                                hide={(state?.tabs === "read-only" || state?.view === "orders" || state?.view === "order")}
                                                controller={controller}
                                                // header={<small>{searchMsg} {(is_modal && !searchMsg && drawReportResultsString())}</small>}
                                                // header={drawTabs()}
                                                constrained_header={drawTabs()}
                                                filterLocal={filterLocal}
                                                signal={signal}
                                                in_stock={in_stock}
                                                switchView={switchView}
                                                isTitleLink={isTitleLink}
                                                state={state}
                                                view={state.view}
                                                align={align}
                                                onSelectedRowClick={() => {
                                                    if (state?.view === "inventory" || state?.view === "inventory_full") {
                                                        kbdEvent(KBD.ENTER)
                                                    }
                                                }}
                                                setAlign={setAlign}
                                                selected={selected}
                                                setSelected={setSelected}
                                                loading={loading}
                                                setLoading={setLoading}
                                                data={data}
                                                setData={setData}
                                                filters={filters}
                                                setFilters={setFilters}
                                                route={route}
                                                search={search}
                                            />
                                        }

                                    </>
                                }

                                {((state.tabs !== "expand" && state.view !== "inventory_full" && state.view !== "orders") &&


                                    <div style={{ "height": "calc(100vh - 431px)", minHeight: "220px", "display": "flex", "flexDirection": "column" }}>
                                        <div className={(state.view === "history") ? "history-box expanded" : "history-box"} style={{ "flex": "1" }}>
                                            <InventoryHistory
                                                state={state}
                                                setState={setState}
                                                fetchExtra={fetchExtra}
                                                controller={controller}
                                                filters={historyFilters}
                                                setFilters={setHistoryFilters}
                                                getOrderDataFromHistoryItem={getOrderDataFromHistoryItem}
                                                onSelectSupplier={(e, read_only = true) => {
                                                    editOrder(e, false)

                                                }}
                                                onEditSupplier={(e, read_only = false) => {
                                                    editOrder(e, false)
                                                }}
                                                onDeleteSupplier={(e) => {

                                                    if (e?.status === "Rcvd") {
                                                        showError({ error: "Received items can only be deleted in Receiving (with this invoice being used)." });
                                                        return
                                                    }

                                                    getOrderDataFromHistoryItem(e, (_s, _r) => {
                                                        if (_s) {
                                                            deleteOrder(_r, controller, window.bm_state.value, () => { }, (_status, _result) => {
                                                                if (_status) {
                                                                    fetchExtra();
                                                                } else {
                                                                    showError(_result);
                                                                }
                                                            })
                                                        }
                                                    })
                                                }}

                                                togglePubstock={togglePubstock}
                                                loading={extrasLoading}
                                                fullData={fullData}
                                                history={fullData?.history}
                                                in_stock={in_stock}
                                                route={ROUTES.INVENTORY.HISTORY}
                                                view={state.view}
                                                switchView={switchView}
                                                selected={selected}
                                                data={[]}
                                            />
                                        </div>
                                    </div>



                                    // <div style={{ "height": "calc(100vh - 430px)", minHeight: "220px", "display": "flex", "flexDirection": "column" }}>
                                    //     <div style={{ "flex": "1", "maxWidth": "610px" }}>
                                    //         <Tabs
                                    //             tabData={tabData}
                                    //             selected={state.tabs}
                                    //             onChange={(e) => setState({ ...state, tabs: e })}
                                    //             content={<div>stuff</div>}
                                    //         >

                                    //         </Tabs>




                                    //     </div>
                                    // </div>

                                )}
                            </Space>
                        )}
                        {/* </div> */}


                        <div style={{ "position": "relative", "width": "100%" }}>
                            <div className="shadow" style={{ "position": "absolute", "bottom": "-1px", "right": "15px", "fontSize": "14px" }}>
                                {(state.pubstock &&
                                    <div ref={(e) => (refs.current["pubstock"] = e)} >

                                        <InventoryPubstock
                                            onSelectSupplier={(e, group = "") => {
                                                if (state?.view === "order") {
                                                    const event = new CustomEvent("updatePubstock", { detail: e });
                                                    window.dispatchEvent(event);
                                                } else {
                                                    if (selected?.condition_code === e?.vendor_type) {
                                                        addAdditive(e, group)
                                                    } else {
                                                        // check for title_link.. 
                                                        if (selected?.title_link) {
                                                            showConfirm({
                                                                controller: controller,
                                                                route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Title doesn't exist<br /><div className="shim" />Create new inventory record?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                                                                    if (_key) {
                                                                        inventory_details_ref?.current?.editTitle({ ...selected, title_link: { ...selected.title_link, "supplier_1": supplierToGroupKey(e?.supplier) || "" } }, (_r) => {
                                                                            let _data = [...data];
                                                                            let _index = _data.findIndex(item => item.stock_id == selected?.stock_id);
                                                                            _data[_index] = _r;
                                                                            setData(_data)
                                                                            setSelected({ ..._data[_index], "new_from_titlelink": true });
                                                                            setTimeout(() => {
                                                                                addAdditive(e, group, _r)
                                                                            }, 50)
                                                                        })
                                                                    }
                                                                }
                                                            })
                                                        } else {
                                                            checkSupplierCondition(selected, e);
                                                        }
                                                    }
                                                }
                                            }}
                                            controller={controller} view={state.view} conditionSelected={conditionSelected} setConditionSelected={setConditionSelected} other_conditions={fullData.other_conditions} setState={(e) => togglePubstock(e)} state={state.pubstock} pending_orders={fullData.pending_orders} loading={extrasLoading} pubstock={fullData?.pubstock} selected={selected} />
                                    </div>
                                )}
                            </div>
                        </div>




                    </div>
                </div>
            </div>
            <div className="shim" />

            <Divider />
            <div style={{ 'height': "30px" }}>
                <Space style={{ "padding": "0px 15px" }}>
                    {(((state.view === "inventory" || state.view === "inventory_full") && !state.edit) && <Nav nav={nav} />)}
                </Space>
            </div>
        </div>
    )


}